import { format, isMatch, parse } from 'date-fns';

const formatDate = (value?: string) => {
  if (!value) return;
  if (value.length < 8) return value;

  //The following regex test is to fix isMatch bug https://github.com/date-fns/date-fns/issues/2072
  let entryFormat =
    /^[0-9]{4}\-[0-9]{1,2}\-[0-9]{1,2}$/.test(value) && isMatch(value, 'yyyy-MM-dd')
      ? 'yyyy-MM-dd'
      : /^[0-9]{1,2}\-[0-9]{1,2}\-[0-9]{4}$/.test(value) && isMatch(value, 'dd-MM-yyyy')
      ? 'dd-MM-yyyy'
      : /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/.test(value) && isMatch(value, 'dd/MM/yyyy')
      ? 'dd/MM/yyyy'
      : '';

  return entryFormat ? format(parse(value, entryFormat, new Date()), 'dd/MM/yyyy') : value;
};

export { formatDate };
